/**
 * Il marchio Blagomail.
 *
 * Una busta il cui lembo è un segno di spunta: posta al primo sguardo, posta
 * già sistemata al secondo. Su fondo chiaro la busta è piena e la spunta è un
 * buco — così il segno resta leggibile senza contorni, che a 20 pixel
 * diventano fango.
 */
import { useId } from 'react';

export function BlagomailMark({ size = 24, tone = 'brand', className }: {
  size?: number;
  /** 'brand' su fondo chiaro, 'white' su fondo colorato: il marchio non ha
   *  contorni, quindi il contrasto deve venire dal pieno. */
  tone?: 'brand' | 'white';
  className?: string;
}) {
  // Le maschere SVG vivono in uno spazio globale: due marchi nella stessa
  // pagina con lo stesso identificativo si mangiano a vicenda.
  const id = useId().replace(/:/g, '');

  return (
    <svg
      width={size} height={size} viewBox="0 0 1024 1024"
      className={className} role="img" aria-label="Blagomail"
    >
      <defs>
        <linearGradient id={`g${id}`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#4F46E5" />
          <stop offset="1" stopColor="#7C3AED" />
        </linearGradient>
        <mask id={`m${id}`}>
          <rect x="216" y="344" width="592" height="356" rx="76" fill="#fff" />
          <path
            d="M288 430 L430 588 L738 412" fill="none" stroke="#000" strokeWidth="66"
            strokeLinecap="round" strokeLinejoin="round"
          />
        </mask>
      </defs>
      <rect
        x="216" y="344" width="592" height="356" rx="76"
        fill={tone === 'white' ? '#FFFFFF' : `url(#g${id})`} mask={`url(#m${id})`}
      />
    </svg>
  );
}
